import {
  GET_HOT_SEARCH_START,
  GET_HOT_SEARCH_APP_START,
  GET_LENOVOWORDS_SEARCH_START,
  GET_RESULT_SEARCH_START,
  GET_SEARCH_RECOMMEND_START,
  CLEAN_SEARCH_RECOMMEND_START,
  GET_FEEDBACK_SUGGEST,
  SET_FEEDBACK_VISIBLE,
  GET_HOT_SEARCH_BOX,
  SET_IS_SEARCH_CLICK,
} from '../constants/search';

export const getHotSearch = () => ({
  type: GET_HOT_SEARCH_START,
});

export const getHotSearchApp = () => ({
  type: GET_HOT_SEARCH_APP_START,
});

export const getLenovoWords = kw => ({
  type: GET_LENOVOWORDS_SEARCH_START,
  kw,
});

export const getSearchResult = param => ({
  type: GET_RESULT_SEARCH_START,
  ...param,
});

export const getSearchRecommend = param => ({
  type: GET_SEARCH_RECOMMEND_START,
  ...param,
});

export const cleanSearchRecommend = () => ({
  type: CLEAN_SEARCH_RECOMMEND_START,
});

export const getFeedbackSuggest = payload => ({
  type: GET_FEEDBACK_SUGGEST,
  payload,
});

export const setFeedbackVisible = payload => ({
  type: SET_FEEDBACK_VISIBLE,
  payload,
});

export const getHotSearchBox = payload => ({
  type: GET_HOT_SEARCH_BOX,
  payload,
});

export const setIsSearchClick = payload => ({
  type: SET_IS_SEARCH_CLICK,
  payload,
});
